import { Fragment, useEffect, useState } from "react";
import { api } from "../lib/api";
import { ReceiveGoodsButton } from "../components/ReceiveGoods";
import { ChevronDown, ChevronRight } from "lucide-react";

const eur = (v) => `€ ${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const n = (v) => Number(v || 0).toLocaleString("it-IT", { maximumFractionDigits: 2 });
const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "—");

export default function ReceiptsPage() {
  const [suppliers, setSuppliers] = useState([]);
  const [f, setF] = useState({ supplier_id: "", date_from: "", date_to: "" });
  const [data, setData] = useState(null);
  const [open, setOpen] = useState({});
  const load = () => api.get("/inventory/receipts", { params: { supplier_id: f.supplier_id || undefined, date_from: f.date_from || undefined, date_to: f.date_to || undefined } })
    .then(r => setData(r.data)).catch(() => setData({ items: [], count: 0, total_spent: 0, by_supplier: [] }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [f]);
  useEffect(() => { api.get("/suppliers").then(r => setSuppliers(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="receipts-page">
      <div className="flex flex-wrap items-end gap-3 mb-6">
        <div><label className="label-caps block mb-2">Fornitore</label>
          <select className="input-dark min-w-[200px]" value={f.supplier_id} onChange={e => setF({ ...f, supplier_id: e.target.value })} data-testid="receipts-filter-supplier">
            <option value="">Tutti</option>
            {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            <option value="none">Senza fornitore</option>
          </select></div>
        <div><label className="label-caps block mb-2">Dal</label>
          <input type="date" className="input-dark" value={f.date_from} onChange={e => setF({ ...f, date_from: e.target.value })} data-testid="receipts-filter-from"/></div>
        <div><label className="label-caps block mb-2">Al</label>
          <input type="date" className="input-dark" value={f.date_to} onChange={e => setF({ ...f, date_to: e.target.value })} data-testid="receipts-filter-to"/></div>
        <div className="ml-auto"><ReceiveGoodsButton onDone={load}/></div>
      </div>
      {!data ? <div className="text-sm opacity-60">Caricamento…</div> : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="card-dark p-5"><div className="label-caps mb-2">Consegne</div><div className="h-editorial text-3xl" data-testid="receipts-count">{data.count}</div></div>
            <div className="card-dark p-5"><div className="label-caps mb-2">Totale speso</div><div className="h-editorial text-3xl" data-testid="receipts-total">{eur(data.total_spent)}</div></div>
            <div className="card-dark p-5"><div className="label-caps mb-2">Per fornitore</div>
              <ul className="text-xs space-y-1 max-h-24 overflow-auto" data-testid="receipts-by-supplier">
                {data.by_supplier.length ? data.by_supplier.map(s => <li key={s.supplier_id || "none"} className="flex justify-between gap-3"><span>{s.name} ({s.count})</span><b>{eur(s.total)}</b></li>)
                  : <li className="opacity-60">—</li>}
              </ul></div>
          </div>
          {data.items.length === 0 ? <div className="text-sm opacity-60 p-10 border border-dashed text-center" data-testid="receipts-empty">Nessuna consegna nel periodo scelto.</div> : (
            <div className="card-dark overflow-x-auto">
              <table className="tbl w-full" data-testid="receipts-table">
                <thead><tr><th></th><th>Data</th><th>Fornitore</th><th>DDT / documento</th><th className="text-right">Materiali</th><th className="text-right">Totale</th></tr></thead>
                <tbody>
                  {data.items.map(r => (
                    <Fragment key={r.id}>
                      <tr className="cursor-pointer" onClick={() => setOpen({ ...open, [r.id]: !open[r.id] })} data-testid={`receipt-row-${r.id}`}>
                        <td className="w-6">{open[r.id] ? <ChevronDown size={14}/> : <ChevronRight size={14}/>}</td>
                        <td>{fmtDate(r.created_at)}</td>
                        <td>{r.supplier_name || <span className="opacity-50">Senza fornitore</span>}</td>
                        <td>{r.reference || "—"}</td>
                        <td className="text-right">{r.lines?.length || 0}</td>
                        <td className="text-right font-medium">{eur(r.total)}</td>
                      </tr>
                      {open[r.id] && (
                        <tr data-testid={`receipt-detail-${r.id}`}><td></td><td colSpan={5} className="text-xs">
                          {r.lines.map(l => (
                            <div key={l.material_id} className="flex justify-between py-1 border-b last:border-0" style={{ borderColor: "var(--border)" }}>
                              <span>{l.name}</span>
                              <span>{n(l.quantity)} {l.unit}{l.unit_cost ? ` × ${eur(l.unit_cost)}` : ""} · giacenza {n(l.stock_before)} → {n(l.stock_after)}</span>
                            </div>
                          ))}
                          {r.notes && <div className="mt-2 opacity-70">Note: {r.notes}</div>}
                        </td></tr>
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
